const menu = document.querySelector('.menu');

if (menu) {
  const closeMenu = () => {
    const openMenus = document.querySelectorAll('.menu__item.is-open');

    openMenus.forEach((item) => {
      item.classList.remove('is-open');
    });
  };

  attachEvent('.menu__arrow', 'click', (ev) => {
    const parent = ev.target.closest('.menu__item');
    const menuDropdown = parent.querySelector('.menu__dropdown');
    parent.classList.toggle('is-open');

    if (windowWidth() < breakpointMd) {
      slideToggle(menuDropdown, 300, 'block');
    }

    ev.preventDefault();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });

  attachEvent('[data-close-menu]', 'click', (ev) => {
    closeMenu();
    ev.preventDefault();
  });
}
